const PaymentMethods = () => import('./PaymentMethods.vue')
const PaymentMethodDetails = () => import('./PaymentMethodDetails.vue')

export default [
  {
    name: 'payment-methods',
    path: 'payment-methods',
    component: PaymentMethods,
    meta: {
      access: ['org.finance.settings']
    },
    children: [
      {
        name: 'payment-method-edit',
        path: ':paymentMethodId/edit',
        components: {
          modal: PaymentMethodDetails
        },
        meta: {
          showModal: true,
          access: ['org.finance.settings']
        }
      },
      {
        name: 'payment-method-new',
        path: 'new',
        components: {
          modal: PaymentMethodDetails
        },
        meta: {
          showModal: true,
          access: ['org.finance.settings']
        }
      }
    ]
  }
]
